import DialogNames from '~/constants/DialogNames'
import useDialog from '~/utils/useDialog'

const useSoapMenuDialogs = ({ soapId }: { soapId?: string }) => {
  const [openAppointmentDialog] = useDialog(DialogNames.EVENT)
  const [openSoapAttachmentDialog] = useDialog(
    DialogNames.SOAP_MULTI_ATTACHMENT,
  )
  const [openNewConversationDialog] = useDialog(
    DialogNames.NEW_CONVERSATION_WITH_STEPS,
  )
  const [openDiagnosisHistoryDialog] = useDialog(DialogNames.DIAGNOSIS_HISTORY)
  const [openNoteHistoryDialog] = useDialog(DialogNames.NOTE_HISTORY)
  const [openAddReminderDialog] = useDialog(DialogNames.ADD_REMINDER)
  const [openVaccineHistoryDialog] = useDialog(DialogNames.VACCINE_HISTORY)
  const [openVitalsDialog] = useDialog(DialogNames.VITALS)
  const [openEstimatesListDialog] = useDialog(DialogNames.ESTIMATES_LIST)
  const [openAppointmentReportCardDialog] = useDialog(
    DialogNames.APPOINTMENT_REPORT_CARD,
    null,
    { soapId },
  )
  const [openPrintCageLabelDialog] = useDialog(DialogNames.PRINT_CAGE_LABEL)
  const [openPrintFolderLabelDialog] = useDialog(DialogNames.PRINT_FOLDER_LABEL)
  const [openPrintPracticeAddressLabelDialog] = useDialog(
    DialogNames.PRINT_PRACTICE_ADDRESS_LABEL,
  )
  const [openTaskDialog] = useDialog(DialogNames.TASK)
  const [openAddendumDialog] = useDialog(DialogNames.ADDENDUM)
  const [openVaccineCertificateValidationDialog] = useDialog(
    DialogNames.VACCINE_CERTIFICATE_VALIDATION,
  )

  return {
    openAppointmentDialog,
    openSoapAttachmentDialog,
    openNewConversationDialog,
    openDiagnosisHistoryDialog,
    openNoteHistoryDialog,
    openAddReminderDialog,
    openVaccineHistoryDialog,
    openVitalsDialog,
    openEstimatesListDialog,
    openAppointmentReportCardDialog,
    openPrintCageLabelDialog,
    openPrintFolderLabelDialog,
    openPrintPracticeAddressLabelDialog,
    openTaskDialog,
    openAddendumDialog,
    openVaccineCertificateValidationDialog,
  }
}

export default useSoapMenuDialogs
